var Actions = /* @__PURE__ */ ((Actions2) => {
  Actions2["setIsLoading"] = "setIsLoading";
  Actions2["setIsLoggedIn"] = "setIsLoggedIn";
  Actions2["setIsOpen"] = "setIsOpen";
  Actions2["setMemberStatus"] = "setMemberStatus";
  return Actions2;
})(Actions || {});
export {
  Actions
};
